<template>
  <span class="badge-container" :class="color">
    {{ count }}
    {{ text }}
  </span>
</template>

<script>
export default {
  name: 'Badge',
  props: {
    count: {
      type: String | Number,
    },
    text: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
  }
}
</script>

<style lang="scss" scoped>
.badge-container {
  padding: 0 0.5rem;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 19.1px;
  color: #FFFFFF;

  &.success {
    background: #007B19;
  }

  &.danger {
    background: #CF0206;
  }

  &.warning {
    background: #FFC107;
  }
}
</style>